var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 595.16,
    height: 154.29,
    viewBox: "0 0 595.16 154.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67,122.63H31.81C13.2,122.63,0,112,0,92.41V.16H12.25V94.64c0,4.29,2.07,8.43,6,12.56,2.55,2.55,7,3.82,13.52,3.82H67Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150,111.18c-9.38,9.39-20.67,14-33.72,13.52a44.38,44.38,0,0,1-32.13-14.31,46.12,46.12,0,0,1-13-32.93,46.59,46.59,0,0,1,14.16-34C94.69,33.92,106,29.31,119,29.78a44.75,44.75,0,0,1,32.13,14.64,46.3,46.3,0,0,1,13.2,32.92Q164.32,96.85,150,111.18Zm-33.56,1.59a31.16,31.16,0,0,0,25.45-10.34,35.32,35.32,0,0,0,10.34-26.08,36.08,36.08,0,0,0-10.34-24.5,31.19,31.19,0,0,0-23.54-10.18c-9.7-.16-17.81,3.34-24.65,10.18A34.12,34.12,0,0,0,83.35,76.51a35.12,35.12,0,0,0,9.38,25.13,32.25,32.25,0,0,0,23.7,11.13Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.6,154.29h-13l13.68-34.52L176.56,32h13.2l29,71.89L249.25,32H262Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M365,122.63H353.27V108.48Q338.48,125.42,317,124.7a44.84,44.84,0,0,1-32-14.47A46.29,46.29,0,0,1,271.8,77.3,46.63,46.63,0,0,1,286,43.3a43.45,43.45,0,0,1,33.88-13.52,45.41,45.41,0,0,1,32.45,14.64c8.91,9.22,13.2,20.2,12.72,32.76v45.45ZM284,76.35a35.22,35.22,0,0,0,9.39,25.13,33.31,33.31,0,0,0,23.7,11.29c10,.48,18.45-3,25.45-10.34A35.69,35.69,0,0,0,353,76.19a35.26,35.26,0,0,0-10.18-24.5,31.53,31.53,0,0,0-23.7-10.18,33.4,33.4,0,0,0-24.66,10.18,34.15,34.15,0,0,0-10.38,24.66Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M389.86,122.63H377.77V0h12.09Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M436.62,124.54c-22.11,0-33.08-9.38-33.08-28.15V.16h12.25V31.81h20.83V43.1H415.79V94.32c0,13.52,7,20.2,20.83,20.2Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M481.32,154.29h-13L482,119.77,447.28,32h13.2l28.95,71.89L520,32h12.72Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M554.3,123.08a3,3,0,0,1-.81,2.16,2.7,2.7,0,0,1-2,.84,2.6,2.6,0,0,1-2-.84,3,3,0,0,1-.78-2.16,3.13,3.13,0,0,1,.78-2.1,2.51,2.51,0,0,1,2-.9,2.59,2.59,0,0,1,2,.9A3,3,0,0,1,554.3,123.08Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M562.58,124.51H558V78.26h4.56Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M595.16,124.51h-5.94l-11.1-13.43-5.46,6.9v6.53h-4.92V78.26h4.74v32.58l15.84-20.52H594l-13,17.22Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7fd22a5dde0cfee6fdd1e657cdca8783.svg";
export { ForwardRef as ReactComponent };